<script>
  import Loader from '../components/Loader.svelte';
  import { loadingStore } from '../stores/General';
</script>

<Loader loading={$loadingStore.loading && !$loadingStore.options?.disableGlobalIndicator} />
